document.addEventListener('click', function (e) {
  const popup = document.querySelector('.career-form-inner');

  if (e.target.closest('.careers__btn')) {
    e.preventDefault();
    if (popup) {
      popup.classList.add('popup-open');
      document.body.classList.add('popup-open');
    }
  }

  if (e.target.closest('.close-icon')) {
    if (popup) {
      popup.classList.remove('popup-open');
      document.body.classList.remove('popup-open');
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
const fileInput = document.querySelector('.career-form #file');
    const selectedFileText = document.querySelector('.selected_file');

    if (fileInput && selectedFileText) {
      fileInput.addEventListener('change', function () {
        const filePath = fileInput.value;
        const filename = filePath.split('\\').pop();

        if (filename) {
          selectedFileText.textContent = filename;
        } else {
          selectedFileText.textContent = 'upload file';
        }
      });
    };
    
  const waitForFileField = setInterval(function () {
    const wrappers = document.querySelectorAll('.career-form .file_inputOuterCS');

    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      const fileInput = wrapper.querySelector('input[type="file"]');
      if (!fileInput) return;

      if (wrapper.querySelector('.file-input-wrap')) return;

      const fileWrap = document.createElement('div');
      fileWrap.className = 'file-input-wrap';

      const fileContent = document.createElement('div');
      fileContent.className = 'file-content';

      const iconDiv = document.createElement('div');
      iconDiv.className = 'file-icon';
      iconDiv.innerHTML = `
        <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.40767 0H1.83333C0.825 0 0 0.825 0 1.83333V16.5C0 17.5083 0.825 18.3333 1.83333 18.3333H12.8333C13.8417 18.3333 14.6667 17.5083 14.6667 16.5V6.259C14.6667 5.77317 14.4732 5.30658 14.1295 4.96283L9.70383 0.537167C9.36008 0.193417 8.8935 0 8.40767 0ZM13.2917 6.41667H8.25V1.375L13.2917 6.41667Z" fill="black"/>
        </svg>
      `;

      const textWrap = document.createElement('span');
      textWrap.className = 'selected_file';
      textWrap.textContent = 'Upload file';

      fileContent.appendChild(iconDiv);
      fileContent.appendChild(textWrap);

      const label = wrapper.querySelector('label');
      if (label) {
        label.insertAdjacentElement('afterend', fileWrap);
      } else {
        wrapper.appendChild(fileWrap);
      }

      fileWrap.appendChild(fileInput);
      fileWrap.appendChild(fileContent);

      fileInput.addEventListener('change', function () {
        if (fileInput.files.length) {
          textWrap.textContent = fileInput.files[0].name;

          if (iconDiv) {
            iconDiv.remove();
          }

        } else {
          textWrap.textContent = 'Upload file';
        }
      });
    });

    clearInterval(waitForFileField);
  }, 200);
});